import useDialogs from './useDialogs';
import { Backdrop, Box, Typography } from '@mui/material';
import BoletiaLogoIcon from '@/components/BoletiaLogoIcon';
import i18n from 'i18next';

export const Loader = ({ msg }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <BoletiaLogoIcon />
      <Typography
        variant="h6"
        component="div"
        sx={{
          color: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[900]
              : theme.palette.grey[100],
          fontSize: '18px',
          fontWeight: 500,
          mt: 4,
        }}
      >
        {msg}
      </Typography>
      {msg === 'Procesando tu pago...' && (
        <Typography
          variant="body2"
          component="div"
          sx={{
            color: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[500]
                : theme.palette.grey[100],
            fontWeight: 400,
            mt: 2,
          }}
        >
          {i18n.t('checkout.loadings.dontCloseWindow')}
        </Typography>
      )}
    </Box>
  );
};

const delay = (time) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, time);
  });

export default function useCallApiProcess(
  promisse,
  msg = i18n.t('checkout.loadings.inProgress'),
  minTime = 0,
  error = null,
) {
  const {
    openModal,
    closeModal,
    alert,
    alertLocale,
    alertBackCode,
    confirm,
    confirmBackCode,
  } = useDialogs();

  const showBackdrop = () =>
    openModal(Backdrop, { children: <Loader msg={msg} /> });

  const callApi = async (...args) => {
    let resp = {};
    try {
      let response;
      showBackdrop();
      if (minTime) {
        const respAll = await Promise.all([promisse(...args), delay(minTime)]);
        if (respAll) {
          response = respAll[0];
        }
      } else {
        response = await promisse(...args);
      }

      if (response.data) {
        resp.data = response.data;
      }

      closeModal();

      if (response.error) {
        resp = { error: response.error };

        if (error) {
          confirm({
            text: error.message,
            title: error.title,
            acceptLabel: error.label,
          });
        } else {
          if (
            response.error.status === 401 &&
            response.error.data?.code === 'INVALID_SESSION_TOKEN'
          ) {
            confirmBackCode(
              response.error.data.code,
              response.error.data.token,
            );
            throw response.error;
          } else if (response.error.status === 409) {
            throw response.error.data.code;
          }
          if (response.error.data) {
            if (response.error.data.code) {
              if (response.error.data.token) {
                confirmBackCode(
                  response.error.data.code,
                  response.error.data.token,
                );
              } else {
                confirmBackCode(response.error.data.code);
              }
            } else if (response.error.data.message) {
              alert(response.error.data.message);
            } else if (response.error.data.messages) {
              alert(response.error.data.messages[0]);
            } else if (response.error.data.errors) {
              alert(response.error.data.errors[0].code);
            }
          } else {
            alert(
              'Tenemos un error en nuestros servidores, por favor intenta más tarde.',
            );
          }
        }
      }
    } catch (e) {
      if (e === 'ADDON_NOT_AVAILABLE') {
        throw e;
      }
      resp = { error: e };
    }

    return resp;
  };

  return {
    callApi,
    openModal,
    closeModal,
    alert,
    alertLocale,
    alertBackCode,
    showBackdrop,
    confirmBackCode,
    confirm,
  };
}
